"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Logo from "../Logo/Logo";
import { getTranslationFor } from "@/text/translations";
import { navigationLinks } from "@/constants/navigation";
import styles from "./Header.module.css";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = usePathname();

  const isLinkActive = (href: string) => {
    if (href === "/") {
      return pathname === "/";
    }
    return pathname?.startsWith(href);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link href="/" className={styles.logoLink}>
          <Logo />
        </Link>

        <button
          className={styles.burgerButton}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span
            className={`${styles.burgerLine} ${isMenuOpen ? styles.burgerLineOpen : ""}`}
          ></span>
          <span
            className={`${styles.burgerLine} ${isMenuOpen ? styles.burgerLineOpen : ""}`}
          ></span>
          <span
            className={`${styles.burgerLine} ${isMenuOpen ? styles.burgerLineOpen : ""}`}
          ></span>
        </button>

        <nav className={styles.nav}>
          {navigationLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className={`${styles.navLink} ${isLinkActive(link.href) ? styles.navLinkActive : ""}`}
            >
              {getTranslationFor(link.title)}
            </Link>
          ))}
        </nav>
      </div>

      <div
        className={`${styles.mobileMenuOverlay} ${isMenuOpen ? styles.mobileMenuOverlayOpen : ""}`}
      >
        <div className={styles.mobileMenuHeader}>
          <Link href="/" className={styles.logoLink}>
            <Logo />
          </Link>
          <button
            className={styles.closeButton}
            onClick={() => setIsMenuOpen(false)}
            aria-label="Close menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
        <nav className={styles.mobileNav}>
          {navigationLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className={`${styles.mobileNavLink} ${isLinkActive(link.href) ? styles.mobileNavLinkActive : ""}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {getTranslationFor(link.title)}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
